import Vue from 'vue'
import app from '../src/App'

new Vue(app).$mount('#app');


/** WEBPACK FOOTER **
 ** ./dev/index.js
 **/